<template>
    <div>
        <v-card>
            <v-img height="80" src="@/assets/images/fondo1.png">
                <v-row class="pa-4" align="center" justify="center">
                    <v-col fluid>
                        <v-list-item-avatar color="purple" size="40" class="ma-0">
                            <v-icon size="30">map</v-icon>
                        </v-list-item-avatar>
                        <span class="headline black--text ma-4">Plan de Estudio</span>
                    </v-col>
                </v-row>
            </v-img>
        </v-card>
        <v-row>
            <v-col cols="4">
                <v-card>
                    <v-card-title style="padding:5px">
                        <v-row>
                            <v-col cols="8" style="padding:2px; padding-left:15px">
                                <v-autocomplete v-model="dIdServicio" label="* Carrera Profesional"
                                    :items="ssPriServiciosIngreso"  item-value="IdServicio" item-text="Descripcion2">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="3" style="padding:1px">
                                <v-select v-model="dPeriodo" label="Periodo" :items="dYears"></v-select>
                            </v-col>
                            <v-col cols="1" style="padding:1px">
                                <v-btn @click.prevent="fuSearch" color="primary" stacked x-large icon><v-icon>search</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                        </v-row>
                    </v-card-title>
                    <v-data-table :headers="dTable.headers" :items="dMatCurriculas" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
                        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning" outlined border="top">No hay registros para mostrar.</v-alert></template>
                        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning" outlined border="top">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
                        <template v-slot:top>
                            <v-toolbar flat style="height:10px;">
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dModal.dialog" max-width="700">
                                    <template v-slot:activator="{}">
                                        <v-btn @click.prevent="fuModalShow" color="success" class="m-0" small><v-icon>add</v-icon> Nuevo</v-btn>
                                    </template>
                                    <template>
                                        <v-card>
                                            <v-card-title class="blue">
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">CCPP : <span class="headline white--text">{{cInicial}}</span></v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">Periodo: <span class="headline white--text" dark>{{dPeriodo}}</span></v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-btn @click="fuModalSave" :loading="dModal.IsUpdating" color="primary"><v-icon>save</v-icon> Guardar</v-btn>
                                                    <v-btn @click="fuModalClose" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                                                </v-list-item>
                                                <!-- <span class="headline" style="color:white">{{!dIdCurricula ? 'Agregar' : 'Editar'}} Plan de Estudio</span>
                                                <v-spacer></v-spacer>
                                                <v-btn :color="!dIdCurricula ? 'primary' : 'warning'" @click="fuModalSave" :loading="dModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                                                <v-btn @click="fuModalClose" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn> -->
                                            </v-card-title>
                                            <v-card-text class="p-0 pt-3">
                                                <v-form ref="refModal">
                                                    <v-row dense>
                                                        <v-col cols="12" xm="4" sm="4" class="pa-1">
                                                            <v-select v-model="dMatCurricula.Nivel" label="* Nivel" :items="dNiveles" :disabled="dModal.IsUpdating" filled prepend-inner-icon="sports_score" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                                        </v-col>
                                                        <v-col cols="12" xm="4" sm="4" class="pa-1">
                                                            <v-select v-model="dMatCurricula.NroBase" label="* Puede desaprobar" :items="['1','2','3','4','5','6','7','8','9','10']" :disabled="dModal.IsUpdating" filled prepend-inner-icon="sports_score" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </v-card-text>
                                        </v-card>
                                    </template>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <!-- <template v-slot:[`item.actions`]="{ item }">
                            <v-menu bottom offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        hola
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template> -->
                        <template v-slot:[`item.Periodo`]="{ item }">
                            {{item.Anio+'-'+item.Periodo}}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="8">
                {{dMatCurriculas}}
            </v-col>
        </v-row>
        <v-snackbar v-model="dSnackbar.value" :color="dSnackbar.color">{{dSnackbar.msg}}
            <v-btn text @click="dSnackbar.value = false"> Cerrar </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import gql from 'graphql-tag';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    name: 'PlanEstudio',
    mounted(){
        let today = new Date();
        for (var i = today.getFullYear()+1; i >= today.getFullYear()-20; i--) {
            this.dYears.push(i+'-2');
            this.dYears.push(i+'-1');
        }
        this.dPeriodo = today.getFullYear()+'-'+(today.getMonth()<=6 ? '1' : '2');
    },
    data: () => ({
        dIdServicio: 2,
        dIdCurricula: null,
        dMatCurriculas: [],
        dMatCurricula: {},
        dModal: {
            dialog: false,
            IsUpdating: false,
        },
        dNiveles: [],
        dPeriodo: null,
        dSnackbar: {
            value: false,
            msg: '',
            color: '',
        },
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'Id', text: 'IdServicio', align: ' d-none'},
                {value: 'priservicio.Iniciales', text: 'Carrera'},
                {value: 'Periodo', text: 'Periodo'},                
                {value: 'Nivel', text: 'Nivel'},
            ],
            loading: false,
            search: '',
        },
        dYears: [],
    }),
    computed: {
        ...mapState(['ssPriServiciosIngreso']),
        cInicial: function () {
            return this.ssPriServiciosIngreso.find(({IdServicio}) => IdServicio == this.dIdServicio).Iniciales;
        }
    },
    methods: {
        async fuSearch() {
            let vPeriodo = this.dPeriodo.split("-");
            this.dTable.loading = true;
            this.dMatCurriculas = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query matcurriculaByIdServicioByAnioByPeriodo($IdServicio: Int!, $Anio: Int!, $Periodo: Int!){
                        matcurriculaByIdServicioByAnioByPeriodo(IdServicio:$IdServicio, Anio: $Anio, Periodo: $Periodo){
                            IdServicio
                            Anio
                            Periodo
                            Nivel
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdServicio: this.dIdServicio,
                        Anio: vPeriodo[0],
                        Periodo: vPeriodo[1],
                    }
                });
                this.dMatCurriculas = response.data.matcurriculaByIdServicioByAnioByPeriodo;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de conexion.', 'error');
            } finally {
                this.dTable.loading = false;
            }
        },
        fuModalShow(){
            this.dIdCurricula = null;
            this.dModal.dialog = true;

            var vNivelAll = [ 1, 2, 3, 4, 5, 6, 7, 8, 9 ];
            var vNivelLista = this.dMatCurriculas.map(item => item.Nivel);

            this.dNiveles = vNivelAll.filter(x => vNivelLista.indexOf(x) === -1);
        },
        fuModalClose(){
            this.dModal.dialog = false;
        },
        fuModalSave(){
            let vPeriodo = this.dPeriodo.split("-");

            this.dMatCurricula.IdServicio = this.dIdServicio;
            this.dMatCurricula.Anio = vPeriodo[0];
            this.dMatCurricula.Periodo = vPeriodo[1];
            console.log(this.dMatCurricula);
            if(!this.$refs.refModal.validate()){
                this.dSnackbar = {value: true, msg: 'Revise el formulario, existe datos erróneos.', color: 'error'};
            } else {
                this.dSnackbar = {value: true, msg: 'ok', color: 'success'};
                // if (this.dIdCurricula)
                // //     this.fuUpdate();
                // // else
                //this.fuCreate();
            }
        },
        async fuCreate () {
            this.dModal.dIsUpdating = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matcurriculaCreate($input: matcurriculaCreateInput!){
                        matcurriculaCreate(input: $input){
                            IdCurricula
                        }
                    }`,
                    variables: {
                        input: this.dMatCurricula
                    }
                });
                if(response.data.matcurriculaCreate){
                    this.dSnackbar = {value: true, msg: 'Se guardó correctamente', color: 'success'};
                    this.fuModalClose();
                    this.fuSearch();
                } else {
                    this.dSnackbar = {value: true, msg: 'No se guardó', color: 'error'};
                }
            } catch (error) {
                console.log(error);
                this.dSnackbar = {value: true, msg: 'No se guardó', color: 'error'};
            } finally {
                this.dModal.dIsUpdating = false;
            }
        },
    }
}
</script>

<style>
</style>